import React, { useState, useEffect } from 'react';
import Popup from 'reactjs-popup';
import { FaEdit, FaPlus } from 'react-icons/fa';
import '../styles/pages/ModalLoan.css';  // You can reuse the same styles

function ModalBranch(props) {
  const [open, setOpen] = useState(false);
  const [content, setContent] = useState(props.value || []);

  useEffect(() => {
    setContent(props.value || []);
  }, [props.value]);

  const onClick = () => {
    setOpen(!open);
  };

  const handleChange = (index, field, value) => {
    const updatedContent = [...content];
    updatedContent[index][field] = value;
    setContent(updatedContent);
  };

  const addRow = () => {
    const newRow = {
      branchName: '',
      address: '',
      branchManager: '',
      latitude: '',
      longitude: ''
    };
    setContent([...content, newRow]);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    props.onSubmit(content);  // Send to parent component or API
    setOpen(false);
  };

  return (
    <div className="modalDiv">
      <FaEdit onClick={onClick} className="edit-icon" />

      <Popup className="editModal" open={open} closeOnDocumentClick={false}>
        <a className="close" onClick={onClick}>&times;</a>
        <p className="modal-title">Edit Branches</p>

        <div className="modal-content" style={{ maxHeight: '55vh', overflowY: 'auto' }}>
          <form onSubmit={handleSubmit}>
            {content.map((item, index) => (
             <div key={index} className="modal-row" style={{ flexWrap: "wrap" }}>
                <div className="text-input-container">
                  <label>Branch Name</label>
                  <input
                    value={item.branchName}
                    onChange={(e) => handleChange(index, 'branchName', e.target.value)}
                  />
                </div>
                <div className="text-input-container">
                  <label>Address</label>
                  <input
                    value={item.address}
                    onChange={(e) => handleChange(index, 'address', e.target.value)}
                  />
                </div>
                <div className="text-input-container">
                  <label>Branch Manager</label>
                  <input
                    value={item.branchManager}
                    onChange={(e) => handleChange(index, 'branchManager', e.target.value)}
                  />
                </div>
                <div className="text-input-container">
                  <label>Latitude</label>
                  <input
                    value={item.latitude}
                    onChange={(e) => handleChange(index, 'latitude', e.target.value)}
                  />
                </div>
                <div className="text-input-container">
                  <label>Longitude</label>
                  <input
                    value={item.longitude}
                    onChange={(e) => handleChange(index, 'longitude', e.target.value)}
                  />
                </div>
              </div>
            ))}

            <div className="add-btn-container">
              <FaPlus onClick={addRow} className="add-btn" />
            </div>

            <button type="submit" className="submit-btn">Submit</button>
          </form>
        </div>
      </Popup>
    </div>
  );
}

export default ModalBranch;
